import React from "react";
import { MdCelebration, MdChurch, MdFlare, MdHandshake, MdNotificationsActive, MdOutlineSelfImprovement } from "react-icons/md";

export const PREVIO_USERS = [
  { id: "1", name: "Jorge de la Garza", role: "Actividad", avatar: "https://i.pravatar.cc/300?u=iu" },
  { id: "2", name: "Andrés Riojas", role: "Charla", avatar: "https://i.pravatar.cc/300?u=po" },
  { id: "3", name: "Mauricio Quintana", role: "Refrigerio", avatar: "https://i.pravatar.cc/300?u=pa" },
  { id: "4", name: "Luis Hernández", role: "Asistencia", avatar: "https://i.pravatar.cc/300?u=ma" },
  { id: "5", name: "Mauricio Quintana", role: "Materiales", avatar: "https://i.pravatar.cc/300?u=sa" },
  { id: "6", name: "Ana Gómez", role: "Cobranza", avatar: "https://i.pravatar.cc/300?u=ta" },
];

export const NORMA_ITEMS = [
  { id: 1, icon: <MdChurch />, label: "Visita", description: "Visita al santisimo", color: "blue.500" },
  { id: 2, icon: <MdHandshake />, label: "Meditación", description: "Meditación con el padre", color: "green.500" },
  { id: 3, icon: <MdNotificationsActive />, label: "Angelus", description: "Rezo del Angelus", color: "red.500" },
  { id: 4, icon: <MdOutlineSelfImprovement />, label: "Oración", description: "Oración en el oratorio", color: "orange.500" },
  { id: 5, icon: <MdFlare />, label: "Bendición", description: "Bendición con el Santisimo", color: "yellow.500" },
  { id: 6, icon: <MdCelebration />, label: "Misa", description: "Celebración de la Santa Misa", color: "purple.500" },
];
